import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { TweetDialog } from '../../../components'
import dateformat from 'dateformat';
import { getWord, WID } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  const { open, text, datetime, checkedImage, checkedSchedule, validTweet, remainingLength, boardImage, url, shortURL, isFetching, isCompleted } = state.tweetDialog
  const { language } = state.user
  var now, buttonLabel
  now = dateformat(new Date(), "isoDateTime").slice(0, -8)
  buttonLabel = checkedSchedule ? getWord(WID.TWEET_DIALOG.SCHEDULE_TWEET_BUTTON, language) : getWord(WID.TWEET_DIALOG.TWEET_BUTTON, language)
  return ({
    open,
    text,
    datetime,
    now,
    checkedImage,
    checkedSchedule,
    remainingLength: remainingLength.toString(10),
    validTweet,
    boardImage,
    url,
    shortURL,
    buttonLabel,
    isFetching,
    isCompleted,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { elementId } = ownProps
  return ({
    handleClose: () => {
      dispatch(actions.tweetDialog.close())
    },
    handleEnter: () => {
      ownProps.onEnter()
    },
    handleEntering: (url, twitterText) => {
      dispatch(api.bitly.fetchMakeShortURL(url, twitterText))
      dispatch(actions.lib.requestCreateBoardImage(elementId))
    },
    handleExited: () => {
      dispatch(actions.lib.clearDownloadImage())
      dispatch(api.bitly.clearShortURL())
      ownProps.onExited()
    },
    handleTextChange: (name, twitterText) => (event) => {
      dispatch(actions.tweetDialog.changedText(name, event.target.value, twitterText))
    },
    handleCheckboxChange: (name) => (event) => {
      dispatch(actions.tweetDialog.changedCheckbox(name, event.target.checked))
    },
    fetchTweet: (text, datetime, image, checkedSchedule, checkedImage) => {
      dispatch(api.twitter.fetchTweet({ text, datetime, image, checkedSchedule, checkedImage }))
    },
  })
}

const mergeProps = ( stateProps, dispatchProps, ownProps ) => {
  const { text, datetime, boardImage, checkedSchedule, checkedImage } = stateProps
  return ({
    ...stateProps,
    ...dispatchProps,
    handleTweet: () => {
      dispatchProps.fetchTweet(text, datetime, boardImage, checkedSchedule, checkedImage)
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(TweetDialog)




// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/TweetDialog.js